module.exports = __webpack_public_path__ + "img/lg1.bc25971c.jpg";